import { SignIn } from "@clerk/clerk-react";
import { Logo } from "@the-drop/ui";

/**
 * Dedicated sign-in route at `/sign-in` (+ splat child for Clerk's internal
 * sub-paths like `/sign-in/factor-one`). The shell-level `Sign in` CTA links
 * here; in-flow auth requests (CheckoutScreen, account screens, order
 * tracking) keep using `<SignInButton mode="modal">` to preserve task state.
 *
 * `redirect_url` query param is read natively by Clerk's `<SignIn>`; when
 * absent, `fallbackRedirectUrl` lands the user at `/`.
 */
export function SignInScreen() {
  return (
    <div className="mx-auto w-full max-w-md space-y-6 pt-12 pb-16">
      <div className="space-y-2 text-center">
        <div className="flex justify-center pb-2">
          <Logo size="md" tone="dark" />
        </div>
        <p className="text-[10px] font-semibold uppercase tracking-[.1em] text-[var(--green)]">
          Drop
        </p>
        <h1 className="text-2xl font-bold tracking-tight text-[var(--text-primary)]">
          Sign in to Drop
        </h1>
        <p className="text-sm text-[var(--text-secondary)]">
          Welcome back. Pick up where you left off.
        </p>
      </div>
      <div className="flex justify-center">
        <SignIn
          routing="path"
          path="/sign-in"
          signUpUrl="/sign-up"
          fallbackRedirectUrl="/"
          appearance={{
            variables: {
              colorPrimary: "var(--green)",
              colorText: "var(--text-primary)",
              colorBackground: "var(--card-bg)",
              borderRadius: "0.75rem",
              fontFamily: "Inter, system-ui, sans-serif",
            },
            elements: {
              card: "shadow-cardMd border border-[var(--card-border)]",
              formButtonPrimary:
                "bg-[var(--green)] hover:bg-[var(--green-dark)] text-sm font-semibold",
              footerActionLink: "text-[var(--green)] hover:text-[var(--green-dark)]",
            },
          }}
        />
      </div>
    </div>
  );
}
